export default {
  // Equipment
  equipment: {
    title: 'Equipment',
    description: 'Track and manage all facility equipment.',
    new: 'New Equipment',
    edit: 'Edit Equipment',
    detail: 'Equipment Detail',
    warranty_alerts: 'Warranty Alerts',
  },

  // Work Orders
  work_orders: {
    title: 'Work Orders',
    description: 'Manage maintenance and repair work orders.',
    new: 'New Work Order',
    edit: 'Edit Work Order',
    detail: 'Work Order Detail',
  },

  // Vendors
  vendors: {
    title: 'Vendors',
    description: 'Manage service vendors and contractors.',
    new: 'New Vendor',
    edit: 'Edit Vendor',
    detail: 'Vendor Detail',
  },

  // Maintenance Schedules
  maintenance_schedules: {
    title: 'Maintenance Schedules',
    add: 'Add Schedule',
    edit: 'Edit Schedule',
    no_schedules: 'No maintenance schedules',
  },

  // Work Order Parts
  parts: {
    title: 'Parts',
    add: 'Add Part',
    edit: 'Edit Part',
    no_parts: 'No parts added',
    total_cost: 'Total Parts Cost',
  },

  // Labels
  labels: {
    name: 'Name',
    category: 'Category',
    status: 'Status',
    location: 'Location',
    manufacturer: 'Manufacturer',
    model_number: 'Model Number',
    serial_number: 'Serial Number',
    installed_at: 'Installed At',
    warranty_expires_at: 'Warranty Expires',
    notes: 'Notes',
    images: 'Images',
    property: 'Property',
    title: 'Title',
    description: 'Description',
    priority: 'Priority',
    equipment: 'Equipment',
    vendor: 'Vendor',
    assigned_to: 'Assigned To',
    maintenance_request: 'Maintenance Request',
    lease: 'Lease',
    due_date: 'Due Date',
    completed_at: 'Completed At',
    completed_by: 'Completed By',
    estimated_cost: 'Estimated Cost',
    actual_cost: 'Actual Cost',
    quality_rating: 'Quality Rating',
    contact_name: 'Contact Name',
    phone: 'Phone',
    email: 'Email',
    address: 'Address',
    specialties: 'Specialties',
    active: 'Active',
    avg_score: 'Average Score',
    frequency: 'Frequency',
    next_due_at: 'Next Due',
    last_completed_at: 'Last Completed',
    quantity: 'Quantity',
    unit_cost: 'Unit Cost',
    total_cost: 'Total Cost',
    created_at: 'Created At',
    recent_work_orders: 'Recent Work Orders',
  },

  // Categories
  categories: {
    hvac: 'HVAC',
    plumbing: 'Plumbing',
    electrical: 'Electrical',
    elevator: 'Elevator',
    fire_safety: 'Fire Safety',
    security: 'Security',
    general: 'General',
  },

  // Equipment Status
  equipment_status: {
    operational: 'Operational',
    needs_repair: 'Needs Repair',
    out_of_service: 'Out of Service',
    decommissioned: 'Decommissioned',
  },

  // Work Order Status
  work_order_status: {
    open: 'Open',
    in_progress: 'In Progress',
    completed: 'Completed',
    cancelled: 'Cancelled',
    all: 'All',
  },

  // Priorities
  priorities: {
    low: 'Low',
    medium: 'Medium',
    high: 'High',
    urgent: 'Urgent',
    all: 'All',
  },

  // Frequencies
  frequencies: {
    daily: 'Daily',
    weekly: 'Weekly',
    biweekly: 'Bi-weekly',
    monthly: 'Monthly',
    quarterly: 'Quarterly',
    semi_annual: 'Semi-Annual',
    annual: 'Annual',
  },

  // Actions
  actions: {
    start_work: 'Start Work',
    complete: 'Complete',
    cancel_order: 'Cancel',
    add_equipment: 'Add Equipment',
    add_work_order: 'Add Work Order',
    add_vendor: 'Add Vendor',
    back_to_list: 'Back to List',
    save: 'Save',
  },

  // Forms
  form: {
    title_new_equipment: 'New Equipment',
    title_edit_equipment: 'Edit Equipment',
    description_new_equipment: 'Add a new piece of equipment to track.',
    description_edit_equipment: 'Update equipment information.',
    title_new_work_order: 'New Work Order',
    title_edit_work_order: 'Edit Work Order',
    description_new_work_order: 'Create a new work order.',
    description_edit_work_order: 'Update work order details.',
    title_new_vendor: 'New Vendor',
    title_edit_vendor: 'Edit Vendor',
    description_new_vendor: 'Add a new vendor or contractor.',
    description_edit_vendor: 'Update vendor information.',
    select_property: 'Select a property',
    select_equipment: 'Select equipment',
    select_vendor: 'Select a vendor',
    select_assigned_to: 'Select assignee',
    select_category: 'Select category',
    select_status: 'Select status',
    select_priority: 'Select priority',
    select_frequency: 'Select frequency',
    no_vendor: 'No vendor',
    no_equipment: 'No equipment',
    no_assignee: 'No assignee',
    no_maintenance_request: 'No maintenance request',
    no_lease: 'No lease',
    lease_locked_caption: 'Linked from the lease deposit settlement, so the lease is locked.',
    equipment_or_lease_hint: 'Select at least one: equipment or a lease.',
    specialties_placeholder: 'e.g. HVAC, Plumbing (comma separated)',
    quality_rating_label: 'Quality Rating (1-5)',
  },

  // Messages
  messages: {
    delete_equipment_title: 'Delete Equipment',
    delete_equipment_confirm: 'Are you sure you want to delete "{{name}}"?',
    delete_work_order_title: 'Delete Work Order',
    delete_work_order_confirm: 'Are you sure you want to delete "{{title}}"?',
    delete_vendor_title: 'Delete Vendor',
    delete_vendor_confirm: 'Are you sure you want to delete "{{name}}"?',
    delete_part_title: 'Delete Part',
    delete_part_confirm: 'Are you sure you want to delete this part?',
    delete_schedule_title: 'Delete Schedule',
    delete_schedule_confirm: 'Are you sure you want to delete this schedule?',
    complete_title: 'Complete Work Order',
    complete_description: 'Rate the quality of work completed (1-5 stars).',
    error_loading: 'Error loading data',
    error_description: 'Something went wrong while loading.',
    created_on: 'Created on {{date}}',
  },

  // Filters
  filters: {
    all_properties: 'All Properties',
    all_categories: 'All Categories',
    all_statuses: 'All Statuses',
    all_priorities: 'All Priorities',
    all_equipment: 'All Equipment',
    all_vendors: 'All Vendors',
    all_assignees: 'All Assignees',
    active_only: 'Active Only',
    search_equipment: 'Search equipment...',
    search_work_orders: 'Search work orders...',
    search_vendors: 'Search vendors...',
  },

  // Empty states
  empty: {
    equipment: 'No equipment found',
    work_orders: 'No work orders found',
    vendors: 'No vendors found',
    not_found: 'Not found',
  },
}
